import * as React from "react";
const IconInvestment = (props) => (
  <svg className={"fill-current"}
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    viewBox="0 0 64 64"
    width={props.size || "48"}
    height={props.size || "48"}
    {...props}
  >
    <path d="M32.2 45.1c1.1 0 2-.9 2-2v-1h.7c3.3 0 6.1-2.7 6.1-6s-2.7-6-6.1-6h-5.2c-1.1 0-2.1-.9-2.1-2s.9-2 2.1-2H38c1.1 0 2-.9 2-2s-.9-2-2-2h-3.8v-1c0-1.1-.9-2-2-2s-2 .9-2 2v1h-.5c-3.3 0-6.1 2.7-6.1 6s2.7 6 6.1 6h5.2c1.1 0 2.1.9 2.1 2s-.9 2-2.1 2h-8.6c-1.1 0-2 .9-2 2s.9 2 2 2h3.8v1c.1 1.1 1 2 2.1 2" />
    <path d="M8.4 31.7c.5 0 .9-.2 1.2-.4l7.1-5.6c.9-.7 1-1.9.3-2.8s-1.9-1-2.8-.3l-3.6 2.9c2.5-10.2 11.6-17.3 22-17.3 10.5 0 19.6 7.1 22.2 17.3.3 1.1 1.4 1.7 2.4 1.4 1.1-.3 1.7-1.4 1.4-2.4-3-12-13.8-20.4-26.1-20.4-12.2 0-22.8 8.2-25.9 20L4.4 21c-.7-.9-1.9-1.1-2.8-.4s-1.1 1.9-.4 2.8l5.6 7.5c.3.4.8.7 1.3.8zM63 44.8l-3.9-8.5c-.2-.5-.6-.9-1.2-1.1-.5-.2-1.1-.1-1.6.1l-8.1 4c-1 .5-1.4 1.7-.9 2.7s1.7 1.4 2.7.9l4-1.9c-3.4 8.9-11.8 14.8-21.4 14.8-9.9 0-18.5-6.3-21.6-15.7-.3-1-1.5-1.6-2.5-1.3s-1.6 1.5-1.3 2.5c3.6 11 13.8 18.4 25.4 18.4 11.1 0 21-6.8 25-17.1l1.7 3.8c.3.7 1.1 1.2 1.8 1.2.3 0 .6-.1.8-.2 1.2-.4 1.6-1.6 1.1-2.6" />
  </svg>
);
export default IconInvestment;
